<template>
    <a-modal
        centered
        title="编辑标签"
        :visible="visible"
        :confirm-loading="submitting"
        @ok="on_ok"
        @cancel="on_cancel"
        :width="420"
        :maskClosable="false"
        :after-close="after_close"
    >
        <template slot="footer">
            <a-button :disabled="submitting" @click="on_cancel">取消</a-button>
            <a-button type="primary" :disabled="submitting" v-if="form.tag_ids.length" @click="on_add">添加到选中标签</a-button>

            <a-button v-if="!form.tag_ids.length" type="danger" :disabled="submitting" @click="on_remove_all">移出所有标签</a-button>

            <a-button v-if="form.tag_ids.length" type="danger" :disabled="submitting" @click="on_remove_selected">移出选中的标签</a-button>
        </template>

        <div class="ids">已选择：{{ record.map((v) => v.name).join("，") }}（共{{ record.length }}人）</div>

        <a-divider>移动到</a-divider>

        <a-form-model :model="form">
            <a-checkbox-group v-model="form.tag_ids" class="b-checkbox">
                <div v-for="item in data_tags" :key="item.id">
                    <a-checkbox :value="item.id" class="checkbox" v-if="!item.is_term">{{ item.name }}</a-checkbox>
                </div>
            </a-checkbox-group>
        </a-form-model>
    </a-modal>
</template>
<script>
    export default {
        data() {
            return {
                form: {
                    member_ids: [],
                    tag_ids: [],
                    type: "add",
                },
                visible: false,
                callback: null,
                record: [],
                submitting: false,
            };
        },
        created() {
            this.$event_bus.$on("visible_member_tags_list", (record, callback) => {
                this.visible = true;
                this.record = record;
                this.callback = callback;

                this.form.member_ids = this.record.map((v) => v.id);
            });
        },
        computed: {
            data_tags() {
                return this.$store.state.member_sidebar_tags;
            },
        },
        methods: {
            on_remove_selected() {
                this.form.type = "remove";
                this.on_ok();
            },
            on_remove_all() {
                this.form.type = "remove_all";
                this.on_ok();
            },
            on_add() {
                this.form.type = "add";
                this.on_ok();
            },
            on_ok() {
                this.submitting = true;
                this.$http
                    .post("member/tags/move", this.form)
                    .then((response) => {
                        if (response.success) {
                            this.$message.success(response.message);
                            this.on_cancel();
                            if (this.callback) {
                                this.callback();
                            }
                        } else {
                            this.$error({
                                title: "失败",
                                centered: true,
                                content: response.message,
                            });
                        }
                    })
                    .catch(() => {})
                    .then(() => {
                        this.submitting = false;
                    });
            },
            on_cancel() {
                this.visible = false;
            },
            after_close() {
                this.form = {
                    member_ids: [],
                    tag_ids: [],
                };
            },
        },
    };
</script>

<style lang="less" scoped>
    .ids {
        font-size: 12px;
    }
</style>
